import axios from 'axios'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

axios.interceptors.request.use((config) => {
  Nprogress.start()
  // config.headers['Authorization'] = 'Bearer fastgpt-fhDDk97moNF8xzOiJM900KZmIODQ05GOI5AfiBuDd59GFFyyhQz6DDQs'
  if (config.method === 'get') {
    config.params = {
      _t: new Date().getTime(),
      ...config.params
    }
  }
  if (config.data) {
    // 删除空字符串的属性
    for (let key in config.data) {
      if (config.data[key] === '') {
        delete config.data[key]
      }
    }
  }
  return config
})
axios.interceptors.response.use(res => {
  Nprogress.done()
  // if (!res?.data?.data) {
  //   res.data.data = res.data.result
  // }
  // // 处理兼容msg 和 message
  // const adapMsg = res?.data?.message || res?.data?.msg
  // res.data.message = adapMsg
  // res.data.msg = adapMsg
  return res
})

// const generateUrl = (url, params) => {
//   url = url + '?'
//   for (let [key, value] of Object.entries(params)) {
//     url = url + key + '=' + value + '&'
//   }
//   return url
// }


// 问答模块---------
export const questionTemplateApi = () => {
  return axios.get('/v1/qaList')
}
